'use-strict';
/**
 * Manages communications with Companion
 */

var RequestClient = require('./RequestClient');
var Provider = require('./Provider');
var Socket = require('./Socket');

module.exports = {
  RequestClient: RequestClient,
  Provider: Provider,
  Socket: Socket
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@uppy/companion-client/lib/index.js
// module id = 1542
// module chunks = 0